import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "billetage-form container p-15 p-md-40" }
const _hoisted_3 = { class: "fw-bold text-black mb-15 mb-md-25" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "div col-md-6" }
const _hoisted_8 = { class: "div form-group mb-12" }
const _hoisted_9 = { class: "div col-md-6" }
const _hoisted_10 = { class: "div form-group mb-12" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = { class: "form-group mb-12" }
const _hoisted_14 = { class: "row justify-content-center" }
const _hoisted_15 = { class: "col-md-8 mb-md-12" }
const _hoisted_16 = { class: "border border-primary mb-5" }
const _hoisted_17 = { class: "px-3" }
const _hoisted_18 = { class: "row align-items-center" }
const _hoisted_19 = { class: "col-md-4 px-1" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { class: "col-md-4 px-1" }
const _hoisted_22 = { class: "col-md-4 px-1" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { class: "montant-total text-center" }
const _hoisted_25 = { class: "mb-3 mt-1 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createVNode(_component_Form, {
        ref: "billetageForm",
        onSubmit: _ctx.addOperation,
        "validation-schema": _ctx.operationSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "div d-flex align-items-center justify-content-between" }, [
                      _createElementVNode("label", { class: "label d-block text-black fw-semibold mb-5" }, [
                        _createTextVNode(" Bénéficiaire"),
                        _createElementVNode("span", { class: "span text-danger" }, "*")
                      ])
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "beneficiaire",
                      class: "form-control compact-input"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "beneficiaire",
                      class: "text-danger"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "div d-flex align-items-center justify-content-between" }, [
                      _createElementVNode("label", { class: "label d-block text-black fw-semibold mb-5" }, " Référence ")
                    ], -1)),
                    _createVNode(_component_Field, {
                      name: "referenceDoc",
                      class: "form-control compact-input"
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "referenceDoc",
                      class: "text-danger"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-5" }, [
                      _createTextVNode(" Motif"),
                      _createElementVNode("span", { class: "text-danger" }, "*")
                    ], -1)),
                    _createVNode(_component_Field, { name: "motif" }, {
                      default: _withCtx(({ field }) => [
                        _createVNode(_component_Multiselect, _mergeProps({
                          modelValue: _ctx.motif,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.motif) = $event)),
                          options: _ctx.motifOptions,
                          "preserve-search": true,
                          searchable: true,
                          placeholder: "Sélectionner le motif",
                          label: "label",
                          "track-by": "value"
                        }, field), null, 16, ["modelValue", "options"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ErrorMessage, {
                      name: "motif",
                      class: "text-danger"
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", {
                      class: "row fw-bold py-2",
                      style: {"background-color":"#a40a0a"}
                    }, [
                      _createElementVNode("div", { class: "col-md-12 text-center" }, [
                        _createElementVNode("h3", { class: "fs-4 text-white" }, "Billetage Décaissement")
                      ])
                    ], -1)),
                    _createElementVNode("div", _hoisted_17, [
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row mt-2" }, [
                        _createElementVNode("div", { class: "col-md-4" }, [
                          _createElementVNode("label", { class: "fw-semibold text-center d-block" }, "Monnaie")
                        ]),
                        _createElementVNode("div", { class: "col-md-4" }, [
                          _createElementVNode("label", { class: "fw-semibold text-center d-block" }, "Quantité")
                        ]),
                        _createElementVNode("div", { class: "col-md-4" }, [
                          _createElementVNode("label", { class: "fw-semibold text-center d-block" }, "Montant")
                        ])
                      ], -1)),
                      _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billetageSortieList, (billetage, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "container-tight m-0 py-1"
                        }, [
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _withDirectives(_createElementVNode("input", {
                                name: "monnaie",
                                "onUpdate:modelValue": ($event: any) => ((billetage.libelle) = $event),
                                readonly: "",
                                class: "form-control compact-input text-center",
                                placeholder: "Monnaie"
                              }, null, 8, _hoisted_20), [
                                [_vModelText, billetage.libelle]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_Field, {
                                name: `billetageSortieList[${index}].qteBillet`,
                                type: "number",
                                min: "0",
                                modelValue: billetage.qteBillet,
                                "onUpdate:modelValue": ($event: any) => ((billetage.qteBillet) = $event),
                                onInput: event => _ctx.handleBilletageInput(event, billetage),
                                onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.restrictInput($event))),
                                class: "form-control compact-input text-center",
                                placeholder: "Qté"
                              }, null, 8, ["name", "modelValue", "onUpdate:modelValue", "onInput"]),
                              _createVNode(_component_ErrorMessage, {
                                name: `billetageSortieList[${index}].qteBillet`,
                                class: "text-danger compact-error text-center"
                              }, null, 8, ["name"])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((billetage.montant) = $event),
                                readonly: "",
                                placeholder: "Montant",
                                class: "form-control compact-input text-center"
                              }, null, 8, _hoisted_23), [
                                [_vModelText, billetage.montant]
                              ])
                            ])
                          ])
                        ]))
                      }), 128)),
                      _createElementVNode("p", _hoisted_24, "Montant Total Décaissement : " + _toDisplayString(_ctx.montantTotalSortie), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _cache[9] || (_cache[9] = _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary top-end"
                }, "Envoyer", -1)),
                _createVNode(_component_router_link, {
                  to: "/ouv_fers/liste-ouv_fer/",
                  class: "btn btn-danger mx-1"
                }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("Annuler")
                  ])),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}